<template>
  <!-- eslint-disable max-len -->
  <LayoutContent>
    <LayoutContent v-if="loading">
      <Loader size="large" />
    </LayoutContent>
    <LayoutContent
      v-else
      inner
      padding
    >
      <div class="box-info">
        <h3 class="title">Simulator</h3>
        <p class="description">After following through the steps then you will able to test it with our simulator.</p>
      </div>
    </LayoutContent>
    <div ref="contentSimulator">
      <LayoutContent
        inner
        padding
        class="mt1"
        v-for="(simulator, index) in listSimulator"
        :key="index"
      >
        <div class="box-simulator">
          <div class="box-header">
            <div
              class="collapse-simulator"
              @click="expandCollapse(index)"
            >
              <p v-bind:ref="'text-'+index">Show</p> <img
                v-bind:ref="'img-'+index"
                src="@/assets/action-icon/icon-arrow-down.svg?external"
              >
            </div>
            <h3
              :ref="'header-title-'+index"
              class="title"
            >Simulator: {{simulator.type}}</h3>
          </div>
          <div
            class="collapse-container"
            v-bind:ref="'collapse-'+index"
          >
            <div
              class="collapse-wrapper"
              v-bind:ref="'wrapper-'+index"
            >
              <div class="wrap-iframe">
                <iframe
                  v-bind:style="'width:'+maxWidthIframe+'px'"
                  @load="onLoadIframe()"
                  :src="simulator.url"
                />

              </div>
              <div
                v-if="simulator.type === 'MANDIRI'"
                style="font-size: 13px;color: #282828;font-weight: 500;"
              > Note: This is a payment simulator, you can input virtual account number to the field above to test payment simulation. As for Mandiri VA Simulator,
                please input 70018 first in the field above before inputing virtual account number. </div>
              <div
                v-else
                style="font-size: 13px;color: #282828;font-weight: 500;"
              > Note: This is a payment simulator, you can input account number to the field above to test payment simulation. </div>
            </div>
          </div>
        </div>
      </LayoutContent>
    </div>
    <div class="btn-container">
      <Button
        @click="onSetStep(3)"
        variant="button"
        size="mini"
      >Previous</Button>
      <Button
        @click="onSetStep(5)"
        variant="button"
        size="mini"
      >Next</Button>
    </div>
  </LayoutContent>
</template>

<script>
/* eslint @typescript-eslint/no-var-requires: "off" */

import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';

@Component({
  components: {
    LayoutContent,
    Select,
    FormInput,
    Button,
    Loader,
  },
})
export default class Step4 extends Vue {
  @Prop(Function) onSetStep;
  maxWidthIframe = 0;
  loading = true;
  listSimulator = [];

  mounted() {
    this.maxWidthIframe = this.$refs.contentSimulator.clientWidth * 4;
    this.getSimulator();
  }

  onLoadIframe() {
    console.clear();
    this.loading = false;
  }

  expandCollapse(e) {
    const refContainer = `collapse-${e}`;
    const refWrapper = `wrapper-${e}`;
    const refImage = `img-${e}`;
    const refText = `text-${e}`;
    const headerTitle = `header-title-${e}`;
    if (this.$refs[refContainer][0].clientHeight) {
      this.$refs[refContainer][0].style.height = 0;
      this.$refs[headerTitle][0].style.borderRadius = '15px';
      // eslint-disable-next-line global-require
      // this.$refs[refImage][0].src = require('@/assets/action-icon/icon-arrow-down.svg?external');
      this.$refs[refText][0].innerHTML = 'Show';
    } else {
      this.$refs[refContainer][0].style.height = `${this.$refs[refWrapper][0].clientHeight}px`;
      this.$refs[headerTitle][0].style.borderBottomLeftRadius = 0;
      this.$refs[headerTitle][0].style.borderBottomRightRadius = 0;
      // eslint-disable-next-line global-require
      // this.$refs[refImage][0].src = require('@/assets/action-icon/icon-arrow-up.svg?external');
      this.$refs[refText][0].innerHTML = 'Hide';
    }
  }

  async getSimulator() {
    this.loading = true;
    const { data } = await api.get('get/simulator');
    this.loading = false;
    if (data.status) {
      this.listSimulator = data.data;
    }
  }
}
</script>

<style scoped>
.box-header {
  position: relative;
}
.collapse-simulator {
  display: flex;
  font-size: smaller;
  position: absolute;
  top: 50%;
  right: -15px;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  cursor: pointer;
}
.collapse-simulator p {
  margin-bottom: 0px;
  line-height: 1.5;
  margin-right: 10px;
  color: #0d4680;
}
.collapse-simulator img {
  height: 20px;
}
.collapse-container {
  -moz-transition: height 0.5s;
  -ms-transition: height 0.5s;
  -o-transition: height 0.5s;
  -webkit-transition: height 0.5s;
  transition: height 0.5s;
  height: 0;
  overflow: hidden;
}
.wrap-iframe {
  /*width: 800px;*/
  height: 450px;
  padding: 0;
  overflow: hidden;
}
.wrap-iframe iframe {
  width: 2500px;
  height: 1500px;
  border: 0px;
}
.wrap-iframe iframe {
  /*margin-left: 12.5%;*/
  margin-top: 20px;
  zoom: 0.5;
  -moz-transform: scale(0.5);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.5);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
}
@-moz-document url-prefix() {
  .wrap-iframe[data-v-cedbcb4e] {
    background: darkgray;
    padding-left: 12%;
  }
  iframe {
    max-width: 100vw;
    max-height: 800px;
    margin: 0 auto;
  }
}
.mt1 {
  margin-top: 10px;
}
.box-simulator .title {
  color: black;
  background: #e4e8eb;
  border-bottom: 1px solid #d5dbe2;
  padding: 15px;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: small;
  border-radius: 15px;
  /* border-top-left-radius: 15px;
  border-top-right-radius: 15px; */
}
.box-info .title {
  color: #288dc2;
  border-bottom: 1px solid #d5dbe2;
  padding-bottom: 7px;
  font-weight: bold;
}
.box-info .description {
  margin-top: 15px;
  font-size: small;
}
.btn-container {
  display: flex;
  /* align-items: end; */
  justify-content: flex-end;
  margin: 15px 15px;
}
</style>
